(function () {
  function openReminderForm(e) {
    var el = e.target.closest('a, button');
    if (!el) return;

    var href = (el.getAttribute('href') || '').trim();
    var dataHref = (el.getAttribute('data-href') || '').trim() || (el.getAttribute('data-url') || '').trim();
    var target = href || dataHref;

    if (target !== '#reminder') return;

    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'V2QQ3j']);
  }

  document.addEventListener('click', openReminderForm, true);
})();
